import React from "react";
import StyledSelect from "../../components/StyledSelect";
import { MODEL_OPTIONS } from "./customizationConstants";

export function CustomizationLlmSection({ customization, setCustomization, styles }) {
  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>Seleção de Modelo de IA</h3>

      <div style={styles.formGroup}>
        <label style={styles.label}>Provedor:</label>
        <StyledSelect
          value={customization.llmProvider}
          onChange={(v) => {
            const defaultModel = MODEL_OPTIONS[v]?.[0]?.value;
            setCustomization((prev) => ({
              ...prev,
              llmProvider: v,
              llmModel: defaultModel ?? prev.llmModel,
            }));
          }}
          options={[
            { value: "anthropic", label: "Anthropic (Claude)" },
            { value: "openai", label: "OpenAI (GPT)" },
            { value: "deepseek", label: "DeepSeek" },
          ]}
          placeholder="Provedor"
        />
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>Modelo:</label>
        <StyledSelect
          value={customization.llmModel}
          onChange={(v) => setCustomization((prev) => ({ ...prev, llmModel: v }))}
          options={MODEL_OPTIONS[customization.llmProvider] || []}
          placeholder="Modelo"
        />
      </div>

      <div style={styles.providerInfo}>
        {customization.llmProvider === "anthropic" && (
          <p>Os modelos Claude são excelentes para tarefas que exigem raciocínio complexo e segurança.</p>
        )}
        {customization.llmProvider === "openai" && (
          <p>Os modelos GPT são versáteis e têm um bom conhecimento geral em vários domínios.</p>
        )}
        {customization.llmProvider === "deepseek" && (
          <p>Os modelos DeepSeek têm bom desempenho e são mais econômicos para uso em grande escala.</p>
        )}
      </div>
    </div>
  );
}
